if (process.env.NODE_ENV === 'development') {
  import('./local-bootstrap');
}

export {};
